import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Dropdown, Input } from 'antd';
import OutsideClickHandler from 'react-outside-click-handler';
import {
  useNavigate, NavigateFunction, useSearchParams, useLocation,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/GlobalSearchContentSlice';
import { actions as searchActions } from 'Slice/GlobalSearchResultsSlice';
import { selectRecentSearches, selectLoading as topicsLoader, selectExpiredPopup } from 'Selector/GlobalSearchContentSelector';
import { Section } from 'Types/GlobalSearchContentTypes';
import {
  getLocalStorageValue, isGuestfromEmail, isSalesforce, validateSearchQuery,
} from 'Utils/UtilityFunctions';
import { usePrevious } from 'Utils/hooks/usePrevious';
import {
  COMPANIES, COMPANY, FEED, GROUPDETAILS, INDUSTRY, INDUSTRIES,
  ONBOARDING, PEOPLE, SRI, SEARCH_ROUTE, USER_EXPIRED_ROUTE, FEED_ROUTE, ADVANCE_SEARCH_ROUTE,
} from 'Utils/Constants';
import { PopUpResponse } from 'Types/PersonTypes';
import classNames from 'classnames';
import { CompliancePopupContent } from 'Types/LoginTypes';
import { useFocus, FocusRefObj } from '../../../Utils/hooks/useFocus';
import { actions as uiActions } from '../../../Slice/UISlice';
import { actions as loginActions } from '../../../Slice/LoginSlice';
import {
  boxShadow,
  primaryBgColor, maxWidth, retina,
  primaryColor, primaryFont, primaryHeadingColor, textBlack, wLight,
  minWidthApp, maxTablet, maxMobile, smMobile,
} from '../../../Utils/utilsStyle';
import { Cross } from '../assets/Cross';
import { GlobalSearchMenu } from './GlobalSearchMenu';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';
import { selectGlobalSearchScreenName } from '../../../Selector/GlobalSearchResultsSelector';
import {
  selectAdvanceSearchMetadataLoading,
  selectAdvanceSearchPeopleForm,
  selectAdvanceSearchCompanyForm,
  selectAdvanceSearchBrmForm,
} from '../../../Selector/AdvanceSearchSelector';
import { globalSearchOpen, selectAdvanceSearchOpen } from '../../../Selector/UISelector';
import { actions as advanceSearchActions } from '../../../Slice/AdvanceSearchSlice';
import GlobalButton from '../../common/components/GlobalButton';
import { AdvanceSearchIcon } from '../../common/assets/svgIcons/AdvanceSearchIcon';
import SearchGlobalIcon from 'Components/common/assets/svgIcons/SearchGlobalIcon';



type Props = {
  iconMode?: boolean;
  groupId?: number;
  highlighted?: boolean;
};

const SearchWrapper = styled.div<{ isAdvanceSearchOpen?: boolean; advanceSearchFormData?: boolean }>`
  position: relative;
  margin-left: 20px;
  &.s-disable {
    background-color: ${primaryBgColor};
    pointer-events: none;
    opacity: 0.5;
    cursor: no-drop;
    input {
      background-color: transparent;
    }
  }
  &.s-hide {
    display: none
  }
  &.shrink-mode{
    min-width: 516px;
    height: 34px;
    margin-right: 10px;
    @media all and (max-width: ${minWidthApp}) {
      min-width: 400px;
    }
    @media all and (max-width: ${maxTablet}) {
      min-width: 300px;
      height: 28px;
    }
    @media all and (max-width: ${maxWidth}) , ${retina} { 
      margin-right: 8px;
    }
    .ant-input-affix-wrapper {
      @media all and (max-width: ${maxTablet}) {
        height: 100%;
      }
    }
  }
  &.icon-mode{
    width: 30px;
    border: none;
    @media all and (max-width: ${maxTablet}) {
      width: 20px;
    }
    .ant-input-affix-wrapper {
      padding: 0px;
      margin-top: 5px;
      border-radius: 0px;
      border: none;
      @media all and (max-width: ${maxTablet}) {
        top: -5px !important;
        width: 32px;
        height: 32px;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 0px 6.512px !important;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        right: 2px;
        padding: 0px !important;
      }
      @media all and (max-width: ${maxMobile}) {
        top: -5px !important;
        width: 22px;
        height: 22px;
      }
      input {
        display: none;
      }
      .ant-input-suffix {
        display: none;
      }
      .ant-input-prefix {
        svg {
          cursor: pointer;
        }
      }
    }
    .ant-input-prefix {
     padding: 0px;
     border-right: none;
     margin-right: 0px;
      svg {
        height: 19px;
        @media all and (max-width: ${maxMobile}) {
          height: 12px;
        }
      }
    }
    .clear-search {
      display: none;
    }
  }
  &.large-mode{
    min-width: 516px;
    height: 34px;
    margin-right: 10px;
    background:white;
    border-radius: 27px;
    box-shadow: ${boxShadow};
    background-color: transparent;
    border-radius: 6px;
    @media all and (max-width: ${minWidthApp}) {
      min-width: 400px !important;
    }
    @media all and (max-width: ${maxMobile}) {
      min-width: 350px !important;
      box-shadow: none;
      margin-left: 0px;
    }
    @media all and (max-width: ${maxTablet}) {
      height: 28px;
      box-shadow: none;
    }

    @media all and (max-width: ${smMobile}) {
      min-width: 300px !important;
      box-shadow:none;
    }

    @media all and (max-width: ${maxWidth}) , ${retina} {
      min-width: 516px;
      margin-right: 8px;
    }
    
    .input-dropdown-wrapper {
      @media all and (max-width: ${maxMobile}) { 
        position: absolute;
        width: 100%;
      }
    }
    .ant-dropdown {
      display: block;
      width: 100%;
      inset: 0px auto auto 0px !important;
      @media all and (max-width: ${maxTablet}) {
        margin-left: 0px;
      }
      @media all and (max-width: ${maxMobile}) {
        inset: 10px auto auto 10px !important;
      }
    }
  }
  .ant-dropdown {
    top: 10px !important;
    z-index: ${({ isAdvanceSearchOpen }) => isAdvanceSearchOpen ? 1 : -1};
    padding-top: ${({ isAdvanceSearchOpen }) => isAdvanceSearchOpen ? '0px' : '20px'};
    background-color: #fff;
    border: 1px solid #C1C1C1;
    border-radius: 6px;
    display: none;
    @media all and (max-width: ${maxTablet}) {
      top: 5px !important;
      border-radius: 6px;
    }
    @media all and (max-width: ${maxMobile}) {
      top: 0px !important;
      left: 0px !important;
      border-radius: 6px;
    }
  }
  .search-field {
    border-radius: 6px;
    &.ant-input-affix-wrapper-lg {
      position: absolute;
      z-index:unset;
      transition: none;
      &.ant-dropdown-open {
        @media all and (max-width: ${maxTablet}){
          height: 28px;
        }
        @media all and (max-width: ${maxMobile}){
          top: -5px;
          right: 3px;
          left:10px;
          position: relative;
          width: 100%;
        }
        .ant-dropdown-menu{
          border-radius:6px;
        }
      }
    }
  }
  .clear-search {
    position: absolute;
    left: -24px;
    z-index: 1;
    width: 14px;
    height: 14px;
    &.shrink-mode-positioning{
      top:22%;
      right: 2%;
    }
  }
  .disabled{
    opacity:0;
    display:none;
    pointer-events:none;
  }
  .pointer-cursor{
    cursor:pointer
  }
  .ant-input-affix-wrapper {
    padding: ${(isAdvanceSearchOpen) => isAdvanceSearchOpen ? '3px 4px 3px 14px' : '3px 30px 3px 11px'};
    @media all and (max-width: ${maxTablet}) {
      padding: ${(isAdvanceSearchOpen) => isAdvanceSearchOpen && '3px 2px 3px 14px !important'};
    }
    input {
    /* on type style */
      font-weight: ${wLight};
      font-size:16px;
      font-family: ${primaryFont};
      letter-spacing: -0.45px;
      color: ${textBlack};
      padding-right: 30px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 14px;
        padding-top: 2px;
      }
      @media all and (max-width: ${maxTablet}) {
        padding-top: 1px;
      }
      &::placeholder {
      /* on placeholder before active */
      font-weight: ${wLight};
      font-size:16px;
      font-family: ${primaryFont};
      letter-spacing: -0.45px;
      color: ${textBlack};
      font-style: normal;
        @media all and (max-width: ${maxTablet}) {
          font-size: 14px;
        }
      }
      &:focus::placeholder {
        /* on placeholder after active */
      color: ${primaryHeadingColor};
      font-family: ${primaryFont};
      font-size: 14px;
      font-weight: ${wLight};
      line-height: 18px;
      letter-spacing: -0.45px;
      font-style: normal;
      opacity: 0.5;
      }
    }
    &:focus {
      border-color: ${primaryColor};
      box-shadow: none;
    }
    &:hover {
      border-color: ${primaryColor};
    }
  }
  .ant-input-prefix {
    padding-right: 12px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding-right: 8px;
    }
    svg {
     width: auto;
     height: 18px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        height: 14px;
      }
    }
  }
  .ant-input-suffix {
    .suffix-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      .advance-search-filter-icon {
        path {
          fill: ${({ advanceSearchFormData }) => advanceSearchFormData && primaryColor};
          stroke: ${({ advanceSearchFormData }) => advanceSearchFormData && primaryColor};
        }
      }
      .advance-search-cross-icon {
        display: ${({ advanceSearchFormData }) => advanceSearchFormData ? 'block' : 'none'};
        cursor: pointer;
        width: 12px;
        height: 12px;
        path {
          fill: ${({ advanceSearchFormData }) => advanceSearchFormData && primaryColor};
        }
        :nth-of-type(2){
          margin-left: ${({ advanceSearchFormData }) => advanceSearchFormData && 'auto'};
        }
      }
    }
    button {
      height: 26px;
      width: ${({ advanceSearchFormData }) => advanceSearchFormData && '140px'};
      border-radius: 6px;
      border: ${({ advanceSearchFormData }) => advanceSearchFormData && `1px solid ${primaryColor}`};
      background-color: ${({ advanceSearchFormData }) => advanceSearchFormData ? '#DEF6E6' : primaryColor};
      color: ${({ advanceSearchFormData }) => advanceSearchFormData && primaryColor};
      padding: ${({ advanceSearchFormData }) => advanceSearchFormData && '0 10px'};
      gap: 4px;
      font-size: 14px;
      line-height: normal;
      @media all and (max-width: ${maxTablet}) {
        font-size: 12px;
        height: 24px;
        border-radius: 4px;
      }
    }
  }
  .ant-input {
    &:focus {
      border-color: ${primaryColor};
    }
  }
  .ant-form-input-control,
  .input.ant-input,
  .input.ant-input:focus {
    outline: none;
    box-shadow: none;
    border: 2px solid ${primaryColor};
  }
  &.z-index-1{
    z-index: 0;
  }
  &.global-search-dropdown {
    &.large-mode {
      @media all and (max-width: ${maxTablet}) {
      position: absolute;
      right: 105px;
      top: 20px;
      z-index: 1;
      }
      @media all and (max-width: ${maxMobile}) {
      position: absolute;
      right: 0px;
      top: 5px;
      z-index: 1;
      }
    }
  }
`;

const GlobalSearch = function GlobalSearch(props: Props) {
  const { iconMode, groupId, highlighted } = props;
  const [searchText, setSearchText] = useState<string>('');
  const [isCrossVisible, setIsCrossVisible] = useState(false);
  const [isLargeMode, setIsLargeMode] = useState(false);
  const previousIsLargeMode = usePrevious(isLargeMode);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const recentSearches: Section = useSelector(selectRecentSearches) as Section;
  const expiredPopup: PopUpResponse = useSelector(selectExpiredPopup);
  const topicsLoading: boolean = useSelector(topicsLoader);
  const navigate: NavigateFunction = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname + location.search;
  const [dataFromChild, setDataFromChild] = useState<string>('');
  const searchScreenName = useSelector(selectGlobalSearchScreenName);
  const advanceSearchOpen = useSelector(selectAdvanceSearchOpen);
  const isSearchOpen = useSelector(globalSearchOpen);
  const advanceSearchMetadataLoading = useSelector(selectAdvanceSearchMetadataLoading);
  const peopleForm = useSelector(selectAdvanceSearchPeopleForm);
  const companyForm = useSelector(selectAdvanceSearchCompanyForm);
  const brmForm = useSelector(selectAdvanceSearchBrmForm);
  const isOnAdvanceSearchPage = pathname.includes(ADVANCE_SEARCH_ROUTE);
  const advanceSearchFormData = isOnAdvanceSearchPage && (
    Object.values(peopleForm).some((v) => v !== '')
    || Object.values(companyForm).some((v) => v !== '')
    || brmForm.name !== '' || brmForm.size !== '' || brmForm.member !== 0 || brmForm.sharedBy !== 0
  );

  const {
    htmlElementRef: inputRef,
    setFocus: setFocusOnInput,
  }: FocusRefObj = useFocus();

  const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = validateSearchQuery(e?.target?.value);
    if (searchQuery.length === 0) {
      setSearchText('');
      setIsCrossVisible(false);
      return;
    }
    setSearchText(searchQuery);
    setIsCrossVisible(true);
  };
  const clearSearch = (e: React.MouseEvent<HTMLOrSVGElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setSearchText('');
    if (isLargeMode === false) {
      setIsLargeMode(true);
    }
    setIsCrossVisible(false);
    setFocusOnInput();
    dispatch(uiActions.isAdvanceSearchOpen(false));
  };

  const clearAdvanceSearch = (e: React.MouseEvent<HTMLOrSVGElement>) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(advanceSearchActions.clearAllForms());
    dispatch(advanceSearchActions.advanceSearchReset());
    dispatch(uiActions.isAdvanceSearchOpen(false));
    navigate(FEED_ROUTE);
  };

  const enableLargeMode = () => {
    setIsLargeMode(true);
    setFocusOnInput();
  };

  const disableLargeMode = () => {
    setIsLargeMode(false);
    dispatch(uiActions.isSearchOpen(false));
    dispatch(uiActions.isAdvanceSearchOpen(false));
  };

  const findTerm = (term: string) => {
    if (pathname.includes(term)) {
      return true;
    }
    return false;
  };

  const getScreenName = () => {
    switch (true) {
      case findTerm(FEED):
        return 'Digest';
      case findTerm(COMPANY):
        return 'Company';
      case findTerm(PEOPLE):
        return 'People';
      case findTerm(SRI):
        return 'Sales Index';
      case findTerm(ONBOARDING):
        return 'Onboarding';
      case findTerm(INDUSTRY):
        return 'Industry';
      case findTerm(GROUPDETAILS):
        return 'People';
      case findTerm(COMPANIES):
        return 'Company';
      case findTerm(INDUSTRIES):
        return 'Industry';
      default:
        return 'Search';
    }
  };

  const getScreenNameFun = () => {
    if (getScreenName() === 'Company') {
      dispatch(companiesActions.setSortingType(''));
    }
    dispatch(actions.setScreenName(getScreenName()));
  };

  const triggerSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      let searchQuery = validateSearchQuery(searchText.trim());
      if (searchQuery.length === 0) {
        return;
      }
      if (searchScreenName === 'addCompanyToServiceLine') {
        dispatch(searchActions.globalSearchResultsResetEmpty());
        dispatch(searchActions.setGlobalSearchLoaded(false));
      }
      if (searchText.split(':').pop()?.trim() !== searchQuery?.trim()) {
        dispatch(searchActions.globalSearchResultsResetEmpty());
        dispatch(searchActions.setGlobalSearchLoaded(false));
      }
      disableLargeMode();
      dispatch(actions.updateRecentSearch(searchQuery));
      getScreenNameFun();
      if (!searchQuery.includes('linkedin.com')) {
        searchQuery = searchQuery?.replace(/&/g, '%26');
      }
      let path = '';

      if (!isSalesforce()) {
        path = `${SEARCH_ROUTE}${searchQuery}`;
        if (pathname.includes(GROUPDETAILS) && groupId && groupId > 0) {
          path = `${path}&groupId=${groupId}`;
        }
        navigate(path, {
          state: {
            enableBackButton: true,
            query: searchText,
            previousPath: currentPath,
          },
        });
      } else {
        const section = searchParams.get('extend') || '';
        path = `${SEARCH_ROUTE}${searchQuery}&extend=${section}`;
      }
      navigate(path, { state: { enableBackButton: true, previousPath: currentPath } });
    }
  };

  useEffect(() => {
    if (!previousIsLargeMode && isLargeMode) setFocusOnInput();
  }, [isLargeMode]);

  const handleAdvanceSearch = () => {
    setIsLargeMode(false);
    dispatch(uiActions.isSearchOpen(false));
    dispatch(uiActions.isAdvanceSearchOpen(true));
    setFocusOnInput();
  }

  const MODES: Record<string, string> = {
    LARGE: 'LARGE',
    SMALL: 'SMALL',
    ICON: 'ICON',
  };
  const modeCSSMap: Record<string, string> = {
    LARGE: 'large-mode',
    SMALL: 'shrink-mode',
    ICON: 'icon-mode',
  };

  const searchMode: string = (() => {
    if (isLargeMode || advanceSearchOpen) {
      return MODES.LARGE;
    }
    if (iconMode) {
      return MODES.ICON;
    }
    return MODES.SMALL;
  })();

  useEffect(() => {
    if (!isSearchOpen && !advanceSearchOpen) {
      setIsLargeMode(false);
    }
  }, [isSearchOpen, advanceSearchOpen]);

  useEffect(() => {
    if (recentSearches.searches && recentSearches.searches.length === 0 && !isGuestfromEmail()) {
      dispatch(actions.globalSearchContent());
      const compliancePopup = getLocalStorageValue('userCompliancePopup');
      if (compliancePopup) {
        const userCompliancePopup = JSON.parse(compliancePopup) as CompliancePopupContent;
        if (userCompliancePopup.complianceId && userCompliancePopup.guidelines) {
          dispatch(loginActions.setCompliancePopup({
            content: userCompliancePopup,
            visible: true,
          }));
        }
      } else {
        dispatch(actions.setApiCalled(true));
      }
    }
  }, []);
  useEffect(() => {
    if (expiredPopup.showPlanPopup) {
      navigate(USER_EXPIRED_ROUTE);
    }
  }, [topicsLoading]);

  const query = searchParams.get('query') ?? '';

  useEffect(() => {
    if (validateSearchQuery(query) !== '') {
      setIsLargeMode(false);
      setSearchText(query);
      setIsCrossVisible(true);
    }
  }, [searchParams]);

  // Function to handle the data received from the child
  const handleDataFromChild = (childData: string) => {
    setDataFromChild(childData);
  };

  useEffect(() => {
    setSearchText(dataFromChild);
  }, [dataFromChild]);

  useEffect(() => {
    setSearchText(query);
  }, [query]);

  return (
    <SearchWrapper
      className={`global-search-dropdown ${modeCSSMap[searchMode]} z-index-1 skiptranslate ${!isSalesforce() ? '' : 's-hide'}`}
      onClick={enableLargeMode}
      isAdvanceSearchOpen={advanceSearchOpen}
      advanceSearchFormData={advanceSearchFormData}
    >
      <OutsideClickHandler onOutsideClick={disableLargeMode}>
        <div
          className={classNames('input-dropdown-wrapper', { highlightedComponent: highlighted })}
          role="button"
          aria-label="Search"
          tabIndex={0}
        >
          <Dropdown
            overlay={(
              <GlobalSearchMenu
                getScreenNameFun={getScreenNameFun}
                onDataPass={handleDataFromChild}
                isAdvanceSearchOpen={advanceSearchOpen}
              />
            )}
            trigger={['click']}
            destroyOnHidden={false}
            open={isLargeMode || advanceSearchOpen}
            getPopupContainer={() => document.querySelector('.input-dropdown-wrapper') as HTMLElement}
            autoAdjustOverflow={false}
            placement="bottom"
          >
            <Input
              size="large"
              placeholder="Search"
              prefix={(

                <SearchGlobalIcon />

              )}
              // suffix={
              //   <div className='suffix-wrapper' onClick={(e) => { e.stopPropagation(); }}>
              //     <Cross className={`clear-search ${isCrossVisible ? 'pointer-cursor' : 'disabled'}  ${isLargeMode ? 'large-mode-positioning' : 'shrink-mode-positioning'}`} onClick={clearSearch} />
              //     <GlobalButton
              //       title={advanceSearchFormData ? 'Selected' : 'Advance Search'}
              //       onButtonClick={handleAdvanceSearch}
              //       IconLeft={<AdvanceSearchIcon />}
              //       IconRight={<Cross className="advance-search-cross-icon" onClick={clearAdvanceSearch} />}
              //       disabled={!!advanceSearchMetadataLoading}
              //     />
              //   </div>
              // }
              className="search-field"
              onChange={onSearchTextChange}
              onClick={(e) => {
                e.stopPropagation();

                setIsLargeMode(true);
                dispatch(uiActions.isAdvanceSearchOpen(false));
                dispatch(uiActions.isSearchOpen(true));
              }}
              value={searchText}
              ref={inputRef}
              onKeyDown={triggerSearch}
              maxLength={300}
            />
          </Dropdown>
        </div>
      </OutsideClickHandler>
    </SearchWrapper>
  );
};

export default GlobalSearch;

GlobalSearch.defaultProps = {
  iconMode: false,
  groupId: 0,
  highlighted: false,
};
